import React, { useEffect, useState, useLayoutEffect } from "react";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";
import { useParams } from "react-router-dom";
import NavBar from "../../components/Navbar/Navbar";

const PandOnderhoudstakenEdit = () => {
  let { id } = useParams();
  const [pandnaam, setPandnaam] = useState("");
  const [huidigeOnderhoudstaken, setHuidigeOnderhoudstaken] = useState([]);
  const [alleOnderhoudstaken, setAlleOnderhoudstaken] = useState([]);

  // Haal alle aan het pand gekoppelde onderhoudstaken op.
  const retrieveHuidigeOnderhoudstaken = () => {
    try {
      axiosInstance.get(`onderhoudstaken-bij-pand/${id}/`).then((response) => {
        setPandnaam(response.data.pandnaam);
        setHuidigeOnderhoudstaken(response.data.onderhoudstaken);
      });
    } catch (e) {
      console.log(e);
    }
  };

  // Haal alle beschikbare onderhoudstaken op.
  const retrieveAlleOnderhoudstaken = () => {
    try {
      axiosInstance.get("onderhoudstaken/").then((response) => {
        setAlleOnderhoudstaken(response.data);
      });
    } catch (e) {
      console.log(e);
    }
  };

  // Verwijder onderhoudstaken die al gekoppeld zijn aan het pand.
  const filterOnderhoudstaken = () => {
    let alleOnderhoudstakenTemp = alleOnderhoudstaken;

    for (let i = 0; i < huidigeOnderhoudstaken.length; i++) {
      for (let j = 0; j < alleOnderhoudstakenTemp.length; j++) {
        if (huidigeOnderhoudstaken[i].id === alleOnderhoudstakenTemp[j].id) {
          alleOnderhoudstakenTemp.splice(j, 1);
        }
      }
    }
    return alleOnderhoudstakenTemp;
  };

  let gefilterdeOnderhoudstaken = filterOnderhoudstaken();

  // Verwijdert een taak uit de ene tabel en voegt deze toe aan de ander.
  const removeOnderhoudstaak = (array1, array2, setOnderhoudstaken, index) => {
    const array1Temp = Object.assign([], array1);
    array2.push(array1Temp[index]);
    array1Temp.splice(index, 1);
    setOnderhoudstaken(array1Temp);
  };

  // Sla wijzigingen op in DB.
  const handleSave = async (e) => {
    e.preventDefault();
    const data = {
      onderhoudstaken: [...huidigeOnderhoudstaken],
    };
    try {
      await axiosInstance.patch(`onderhoudstaken-bij-pand/${id}/`, data).then( response => {
        try{
          if(response.response.status==403){
            alert("Forbidden! You do not have permission to perform this action.");
            return (window.location = "/app/");
          } else {
            alert("Bewerking voltooid!");
            return (window.location = "/app/");
          };
        } catch(e){
          alert("Bewerking voltooid!");
          return (window.location = "/app/");
          console.log("operation seems successfull, known error",e);
        }
      });
      return (window.location = `/app/panden/${id}/`);
    } catch (e) {
      alert("Er is iets mis gegaan..");
      console.log(e);
    }
  };

  // Maak voor elke onderhoudstaak een tabel-rij aan. Geef als argument (typeOnderhoudstaken) de te gebruiken array op.
  const toonOnderhoudstaken = (typeOnderhoudstaken) => {
    return typeOnderhoudstaken.map((onderhoudstaak, index) => {
      return (
        <tr key={index}>
          <td>{onderhoudstaak.omschrijving}</td>
          <td>{onderhoudstaak.kosten}</td>
          <td>
            {typeOnderhoudstaken === huidigeOnderhoudstaken ? (
              <button
                onClick={() =>
                  removeOnderhoudstaak(
                    huidigeOnderhoudstaken,
                    alleOnderhoudstaken,
                    setHuidigeOnderhoudstaken,
                    index
                  )
                }
                className="button is-danger is-small is-outlined"
              >
                <i className="far fa-trash-alt"></i>
                <strong>Remove</strong>
              </button>
            ) : (
              <button
                onClick={() =>
                  removeOnderhoudstaak(
                    alleOnderhoudstaken,
                    huidigeOnderhoudstaken,
                    setAlleOnderhoudstaken,
                    index
                  )
                }
                className="button is-primary is-small is-outlined"
              >
                <i className="fas fa-plus-circle"></i>
                <strong>Add</strong>
              </button>
            )}
          </td>
        </tr>
      );
    });
  };

  useEffect(() => {
    retrieveHuidigeOnderhoudstaken();
    retrieveAlleOnderhoudstaken();
    setAlleOnderhoudstaken(gefilterdeOnderhoudstaken);
  }, []);

  return (
    <>
      <NavBar />
      <section className="section">
        <div className="container">
          <p className="title is-2">Bewerk onderhoudstaken voor {pandnaam}</p>
          <div className="field is-grouped">
            <div className="control">
              <button
                onClick={handleSave}
                className="button is-primary is-outlined"
              >
                <i className="far fa-save"></i>
                <strong>Wijzigingen opslaan</strong>
              </button>
            </div>
            <div className="control">
              <button
                onClick={() => (window.location = `/app/panden/${id}`)}
                className="button is-danger is-outlined"
              >
                <i className="fas fa-ban"></i>
                <strong>Annuleren</strong>
              </button>
            </div>
          </div>
          <br />
          <div className="columns">
            <div className="column">
              <p className="title is-4">Huidige onderhoudstaken</p>
              <div className="box">
                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Omschrijving</th>
                      <th>Kosten</th>
                      <th>Actie</th>
                    </tr>
                  </thead>
                  <tbody>{toonOnderhoudstaken(huidigeOnderhoudstaken)}</tbody>
                </table>
              </div>
            </div>
            <div className="column">
              <p className="title is-4">Beschikbare onderhoudstaken</p>
              <div className="box">
                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Omschrijving</th>
                      <th>Kosten</th>
                      <th>Actie</th>
                    </tr>
                  </thead>
                  <tbody>{toonOnderhoudstaken(alleOnderhoudstaken)}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PandOnderhoudstakenEdit;

// const removeHuidigeTaak = (index) => {
//   const huidigeOnderhoudstakenTemp = Object.assign(
//     [],
//     huidigeOnderhoudstaken
//   );
//   alleOnderhoudstaken.push(huidigeOnderhoudstakenTemp[index]);
//   huidigeOnderhoudstakenTemp.splice(index, 1);
//   setHuidigeOnderhoudstaken(huidigeOnderhoudstakenTemp);
// };

// const removeBeschikbareOnderhoudstaak = (index) => {
//   const alleOnderhoudstakenTemp = Object.assign([], alleOnderhoudstaken);

//   huidigeOnderhoudstaken.push(alleOnderhoudstakenTemp[index]);
//   alleOnderhoudstakenTemp.splice(index, 1);
//   setAlleOnderhoudstaken(alleOnderhoudstakenTemp);
// };
